module.exports = __webpack_public_path__ + "static/step-3-f3d1f0f2970d354cd2257b109ffe7022.svg";